<template>
    <section>
        <p class='title'>
            <a name="detail"><span>爱排名</span>快速排名系统</a>
        </p>
        <p class='intro'>按效果计费，一键退款保障</p>
        <p class='point'>低成本 · 易操作 · 见效快</p>

        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <ul class='chargeIntro'>
                        <li>
                            <img src="../assets/images/circle.png" alt="">
                            <div>
                                <p class='title'>积分优化</p>
                                <p class='subTitle'>服务客户类型</p>
                                <p class='content'>关键词在搜索引擎100名内有排名，想快速提升关键词排名，或关键词排名不稳定，可用积分进行维护优化。</p>
                            </div>
                        </li>
                        <li>
                            <img src="../assets/images/line.png" class='line' alt="">
                            <div>
                                <p class='pointIntro'>积分优化介绍</p>
                                <p class='content'>
                                    <span>每天最低只需1元钱，</span>系统自动计费，价格透明杜绝隐形消费。快速提升百度PC、百度移动、360、搜狗全网排名。排名效果可视，易监控易查询。
                                </p>
                                <p class='term'>优化周期：7-45天</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="swiper-slide">
                    <ul class='chargeIntro'>
                        <li>
                            <img src="../assets/images/circle.png" alt="">
                            <div>
                                <p class='title'>快速排名</p>
                                <p class='subTitle'>服务客户类型</p>
                                <p class='content'>关键词有排名而没有达到搜索结果首页或前三的词，可以通过提升快照评级和改进搜索体验进行排名快速提升服务。</p>
                            </div>
                        </li>
                        <li>
                            <img src="../assets/images/line.png" class='line' alt="">
                            <div>
                                <p class='pointIntro'>快速排名介绍</p>
                                <p class='content'>
                                    <span>快速排名最快3天</span>快速提升关键词排名百度首页前三，我们保证关键字排名效果，约定30天内进入百度首页为达标，
                                    百度优化关键词不达标不扣实际费用。百度关键词优化周期有保障，网站关键词优化每月达标最低保障20天。
                                </p>
                                <p class='term'>优化周期：3-30天</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="swiper-slide">
                    <ul class='chargeIntro'>
                        <li>
                            <img src="../assets/images/circle.png" alt="">
                            <div>
                                <p class='title'>seo优化</p>
                                <p class='subTitle'>服务客户类型</p>
                                <p class='content'>客户网站无排名，无流量，无收录，想要快速提升站点排名访问量和收录的客户。</p>
                            </div>
                        </li>
                        <li>
                            <img src="../assets/images/line.png" class='line' alt="">
                            <div>
                                <p class='pointIntro'>SEO优化介绍</p>
                                <p class='content'>
                                    <span>SEO优化</span>是指客户新站无排名，选择关键词并约定排名位置。委托爱排名公司进行SEO服务。按达标计费，不达标不收取任何费用。10年seo技术积累，百名SEO工程师，全面分析客户新站点，从SEO结构，给出合理科学的分析报告和优化策略，为客户站点SEO排名报价护航。
                                </p>
                                <p class='term'>优化周期：15-60天</p>
                            </div>
                        </li>
                    </ul>

                </div>
                <div class="swiper-slide">
                    <ul class='chargeIntro'>
                        <li>
                            <img src="../assets/images/circle.png" alt="">
                            <div>
                                <p class='title'>整站优化</p>
                                <p class='subTitle'>服务客户类型</p>
                                <p class='content'>
                                    整站优化即不以追求个别关键词的排名为目的，不仅限于对首页或某几个页面进行优化，而是通过对网站进行全面优化，全面提升网站整体百度权重（BR）。</p>
                            </div>
                        </li>
                        <li>
                            <img src="../assets/images/line.png" class='line' alt="">
                            <div>
                                <p class='pointIntro'>整站优化介绍</p>
                                <p class='content'>
                                    <span>通过整站优化</span>，让您的网站在搜索引擎的表现全面提升，大量长尾关键词上线为您带来大量高转化率的优质流量。
                                    随着网站权重的提高，以及网站被搜索引擎收录的页面越来越多，上线的关键词也会越来越多，流量就会越来越高，
                                    并且，随着网站权重越来越高，以及大量长尾关键词的带动，核心关键词的排名也将越来越靠前，推广效果越来越好!
                                </p>
                                <p class='term'>优化周期：30-180天</p>
                            </div>
                        </li>
                    </ul>

                </div>
                <!--<div class="swiper-button-next"></div>-->
                <!--<div class="swiper-button-prev"></div>-->

            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <!--<div class="swiper-pagination">-->

            <!--</div>-->
            <!--<ul class="swiper-pagination">-->
            <!--<li class="active"></li>-->
            <!--<li ></li>-->
            <!--<li ></li>-->
            <!--<li></li>-->
            <!--</ul>-->

        </div>

        <img class='simpleIntroBg' src="../assets/images/simpleIntro.png" alt="">

        <div class="reason">
            <img class='liuxing1' src="../assets/images/liuxing1.png" alt="">
            <img class='liuxing2' src="../assets/images/liuxing2.png" alt="">
            <div class="imgBg">
                <img class='zhizhu' src="../assets/images/zhizhu3.png" alt="">
                <img src="../assets/images/flashLight1.png" alt="" class="flashLight1">
                <img src="../assets/images/flashLight2.png" alt="" class="flashLight2">
                <img src="../assets/images/flashLight3.png" alt="" class="flashLight3">
                <img src="../assets/images/flashLight4.png" alt="" class="flashLight4">
                <img src="../assets/images/flashLight5.png" alt="" class="flashLight5">
                <img src="../assets/images/flashLight6.png" alt="" class="flashLight6">
            </div>
            <div class="reasonTop">
                <div class="reasonTitle">为什么选择<span>爱排名SEO？</span></div>
                <div class="reasonSuccess">10年SEO技术沉淀，成功上词10W+</div>
                <div class="reasonMore">
                    <span class="reasonText">更快</span>
                    <span class="reasonCircle"></span>
                    <span class="reasonText">更稳</span>
                    <span class="reasonCircle"></span>
                    <span class="reasonText">更前</span>
                </div>
            </div>
            <div class="reasonBottom clean">
                <ul>
                    <li class="reasonItem" :class='{active: item.active}' @mouseover="changeActive(item)"
                        @mouseout='changeInactive(item)' v-for='item in leftList' :key='item.id'>
                        <p class="TitleImg" v-if='!item.active'>
                            <img :src="item.titleIcon1" class='titleIc
                            on'>{{item.title}}
                        </p>
                        <p class="TitleImg" v-if='item.active'>
                            <img :src="item.titleIcon2" v-if='item.active' class='titleIcon'>{{item.title}}
                        </p>
                        <p class="reasonContent">{{item.content}}</p>
                        <img :src="item.bigIcon" class='bigIcon' alt="">
                        <img :src="item.bigIcon2" v-if='item.active' class='bigIcon' alt="">
                    </li>
                </ul>
                <ul>
                    <li class="reasonItem" :class='{active: item.active}' @mouseover="changeActive(item)"
                        @mouseout='changeInactive(item)' v-for='item in rightList' :key='item.id'>
                        <p class="TitleImg" v-if='!item.active'>
                            <img :src="item.titleIcon1" class='titleIcon'>{{item.title}}
                        </p>
                        <p class="TitleImg" v-if='item.active'>
                            <img :src="item.titleIcon2" v-if='item.active' class='titleIcon'>{{item.title}}
                        </p>
                        <p class="reasonContent">{{item.content}}</p>
                        <img :src="item.bigIcon" class='bigIcon' alt="">
                        <img :src="item.bigIcon2" v-if='item.active' class='bigIcon' alt="">
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>
    import Swiper from 'swiper';

    export default {
        name: 'SimpleIntro',
        data() {
            return {
                leftList: [{
                    id: 1,
                    titleIcon1: require('../assets/images/shubiao.png'),
                    titleIcon2: require('../assets/images/shubiao2.png'),
                    title: '系统易操作',
                    content: '系统操作简单，只需要添加网址和关键词的一步操作就能坐等排名效果！使您的优化任务省时、省事、省资源！',
                    bigIcon: require('../assets/images/system.png'),
                    bigIcon2: require('../assets/images/redLap.png'),
                    active: false,
                }, {
                    id: 2,
                    titleIcon1: require('../assets/images/quickEffect.png'),
                    titleIcon2: require('../assets/images/quickEffect2.png'),
                    title: '优化快，效果好',
                    content: '爱排名SEO系统，最低每天只需1元钱，最快7天上百度首页，优化费用低于行业同类产品！系统坚持用低的成本做好的效果！',
                    bigIcon: require('../assets/images/system.png'),
                    bigIcon2: require('../assets/images/redLap.png'),
                    active: false,
                }, {
                    id: 3,
                    titleIcon1: require('../assets/images/watcher.png'),
                    titleIcon2: require('../assets/images/watcher2.png'),
                    title: '智能排名监控系统',
                    content: '智能监控系统让排名效果以及费用消耗一目了然，方便用户随时随地均可查看排名效果的实时数据！',
                    bigIcon: require('../assets/images/system.png'),
                    bigIcon2: require('../assets/images/redLap.png'),
                    active: false,
                }],
                rightList: [{
                    id: 1,
                    titleIcon1: require('../assets/images/VIP.png'),
                    titleIcon2: require('../assets/images/VIP2.png'),
                    title: '一对一VIP服务',
                    content: '专家顾问团队一对一解决问题，咨询即送SEO免费诊断报告。',
                    bigIcon: require('../assets/images/system.png'),
                    bigIcon2: require('../assets/images/redLap.png'),
                    active: false,
                }, {
                    id: 2,
                    titleIcon1: require('../assets/images/charging.png'),
                    titleIcon2: require('../assets/images/charging2.png'),
                    title: '上线后再计费',
                    content: '爱排名开创SEO优化行业服务标准，优化达标后再计费，不浪费用户一分钱，不达标不扣费。',
                    bigIcon: require('../assets/images/system.png'),
                    bigIcon2: require('../assets/images/redLap.png'),
                    active: false,
                }, {
                    id: 3,
                    titleIcon1: require('../assets/images/refund.png'),
                    titleIcon2: require('../assets/images/refund2.png'),
                    title: '支持退款',
                    content: '所有推广产品在约定时间内没有达标，平台支持退款，用户可以在会员中心申请退费。',
                    bigIcon: require('../assets/images/system.png'),
                    bigIcon2: require('../assets/images/redLap.png'),
                    active: false,
                }]
            }
        },
        methods: {
            changeActive(item) {
                item.active = true;
            },
            changeInactive(item) {
                item.active = false;
            }
        },
        mounted() {
            var mySwiper = new Swiper('.swiper-container', {
                autoplay: true,
                speed: 1000,
                loop: true,
                pagination: '.optimizeCircle',//分页容器的css选择器
                paginationType: 'custom',//自定义-分页器样式类型（前提）
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                //设置自定义分页器的内容
                paginationCustomRender: function (swiper, current, total) {
                    var _html = '';
                    for (var i = 1; i <= total; i++) {
                        alert(current)
                        if (current == i) {
                            _html += '<li class=" active"></li>';
                        } else {
                            _html += '<li class=""></li>';
                        }
                    }
                    return _html;//返回所有的页码html
                }
            })
            // mySwiper.on('slideChange', function () {
            //     alert('slide changed');
            // });
        }
    }
</script>

<style lang='scss' scoped>
    @import '../../node_modules/swiper/dist/css/swiper.css';

    section {
        margin-top: 40px;
        position: relative;
        left: 0;
        top: 0;
        .title {
            font-size: 40px;
            span {
                color: #FC5F35;
            }
        }
        .chargeIntro {
            p {
                text-align: justify;
            }
        }
        .intro {
            font-size: 16px;
            color: #999;
            margin: 20px;
        }
        .point {
            font-size: 30px;
        }
        .swiper-wrapper, .swiper-slide {
            max-height: 340px !important;
        }
        .chargeIntro {
            margin: 30px 2.5rem;
            background: #fff;
            display: flex;
            padding: 50px 80px 50px 80px;
            border: 1px solid #fff;
            position: relative;
            left: 0;
            top: 0;
            z-index: 10;
            &:hover {
                cursor: pointer;
                /*border: 1px solid #FC5F35;*/
            }
            li {
                padding-left: 120px;
                width: 50%;
                position: relative;
                left: 0;
                top: 0;
                text-align: left;
                img {
                    position: absolute;
                    left: 10px;
                    top: 0px;
                    width: 68px;
                }
                .title {
                    font-size: 30px;
                    font-weight: 600;
                }
                .subTitle {
                    font-size: 18px;
                    color: #A7ADCC;
                    margin: 20px 0 6px;
                    font-weight: 600;
                }
                .content {
                    font-size: 16px;
                    color: #7F7D8D;
                    line-height: 26px;
                    span {
                        color: #FC5F35;
                    }
                }
                .pointIntro {
                    font-size: 18px;
                    color: #A7ADCC;
                    margin-bottom: 8px;
                    font-weight: 600;
                }
                .term {
                    color: #FC5F35;
                    margin-top: 20px;
                    font-size: 18px;
                }
                &:nth-of-type(2) {
                    padding-left: 80px;
                    width: 45%;
                    img {
                        position: absolute;
                        left: 36px;
                        top: -25px;
                        width: 1px;
                    }
                }
            }
        }
        .pagination {
            position: absolute;
            z-index: 20;
            bottom: 10px;
            width: 100%;
            text-align: center;
        }
        .swiper-pagination-switch {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 8px;
            background: #555;
            margin: 0 5px;
            opacity: 0.8;
            border: 1px solid #fff;
            cursor: pointer;
        }
        .swiper-active-switch {
            background: red;
        }
        .simpleIntroBg {
            position: absolute;
            right: 0.8rem;
            top: 451px;
            width: 6.5rem;
            z-index: 5;
        }
        .optimizeCircle {
            width: 88px;
            height: 14px;
            margin: 50px auto 0;
            padding-bottom: 50px;
            li {
                float: left;
                width: 12px;
                height: 12px;
                background: #ddd;
                border-radius: 50%;
                opacity: 1;
                margin-left: 6px;
                cursor: pointer;
                &.active {
                    background: rgba(252, 95, 53, 1);
                }
            }
        }
        .reason {
            padding: 0 2.5rem;
            height: 750px;
            background: rgba(33, 35, 47, 1);
            opacity: 1;
            position: relative;
            left: 0;
            top: 0;
            .liuxing1, .liuxing2, .zhizhu, .flashLight1, .flashLight2, .flashLight3, .flashLight4, .flashLight5, .flashLight6 {
                position: absolute;
                top: 0;
                z-index: 40;
            }
            .imgBg {
                position: absolute;
                left: 50%;
                top: 80px;
                width: 500px;
                height: 400px;
                transform: translateX(-50%);
                .zhizhu {
                    width: 100%;
                    top: 0;
                    left: 0;
                }
                .flashLight1 {
                    left: 70px;
                    top: 180px;
                    width: 100px;
                }
                .flashLight2 {
                    left: 80px;
                    top: 350px;
                    width: 70px;
                }
                .flashLight3 {
                    left: 95px;
                    top: 426px;
                    width: 70px;
                }
                .flashLight4 {
                    right: 75px;
                    top: 426px;
                    width: 70px;
                }
                .flashLight5 {
                    right: 60px;
                    top: 350px;
                    width: 70px;
                }
                .flashLight6 {
                    right: 50px;
                    top: 180px;
                    width: 100px;
                }
            }
            .liuxing1 {
                left: -100px;
                width: 2.8rem;
            }
            .liuxing2 {
                right: 0;
                width: 2.3rem;
                top: 200px;
            }
            .reasonTop {
                width: 542px;
                height: 180px;
                margin: auto;
                padding-top: 30px;
                padding-left: 16px;
                .reasonTitle {
                    width: 542px;
                    height: 55px;
                    font-size: 38px;
                    font-family: Microsoft YaHei;
                    line-height: 50px;
                    color: #fff;
                    text-align: center;
                    span {
                        color: #FC5F35;
                    }
                }
                .reasonSuccess {
                    width: 542px;
                    height: 23px;
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 23px;
                    color: rgba(167, 173, 204, 1);
                    opacity: 1;
                    text-align: center;
                    margin-top: 10px;
                }
                .reasonMore {
                    margin-top: 15px;
                    .reasonText {
                        display: inline-block;
                        width: 68px;
                        height: 39px;
                        font-size: 28px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 39px;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                        margin-left: 16px;
                        &:nth-of-type(1) {
                            margin: 0;
                        }
                    }
                    .reasonCircle {
                        display: inline-block;
                        width: 8px;
                        height: 8px;
                        background: rgba(255, 255, 255, 1);
                        border-radius: 50%;
                        opacity: 1;
                        margin-bottom: 6px;
                        margin-left: 16px;
                    }
                }
            }
            .reasonBottom {
                width: 100%;
                height: 500px;
                display: flex;
                justify-content: space-between;
                ul {
                    flex: 1;
                    position: relative;
                    left: 0;
                    top: 0;
                    .reasonItem {
                        width: 260px;
                        height: 150px;
                        background: #1b1e2b;
                        border-radius: 6px;
                        position: absolute;
                        top: 0;
                        right: 140px;
                        z-index: 18;
                        padding-right: 70px;
                        cursor: pointer;
                        &:nth-of-type(2) {
                            top: 180px;
                            .TitleImg {
                                padding-left: 46px;
                                img {
                                    width: 25px;
                                    height: 25px;
                                    top: 8px;
                                }
                            }
                        }
                        &:nth-of-type(3) {
                            top: 360px;
                            .TitleImg {
                                padding-left: 46px;
                                img {
                                    width: 25px;
                                    height: 25px;
                                    top: 8px;
                                }
                            }
                        }
                        &.active {
                            background: #40485C;
                        }
                        .TitleImg {
                            height: 40px;
                            line-height: 40px;
                            font-size: 20px;
                            color: #fff;
                            font-weight: 600;
                            position: relative;
                            left: 0;
                            top: 0;
                            width: 100%;
                            padding-left: 40px;
                            text-align: left;
                            margin-top: 8px;
                            white-space: nowrap;
                            img {
                                position: absolute;
                                left: 15px;
                                top: 3px;
                                height: 28px;
                            }
                        }
                        .reasonContent {
                            padding-left: 15px;
                            position: relative;
                            left: 0;
                            top: 0;
                            text-align: left;
                            font-size: 13px;
                            line-height: 18px;
                            color: #aaa;
                        }
                        .bigIcon {
                            position: absolute;
                            right: 15px;
                            bottom: 30px;
                            width: 50px;
                            z-index: 16;
                        }
                    }
                    &:nth-of-type(2) {
                        li {
                            left: 160px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SimpleIntro.vue